import React from 'react'

function Recarga() {
  return (
    <div>Recarga</div>
  )
}

export default Recarga